import {
  getToken,
  getUser,
} from "../../../../Components/Helpers/Utilities/Common";
import {
  postAPICallwithFile,
  postAPICall,
  getWithParamsAPICall,
} from "../../../../Components/Helpers/API/axiosMethodCall";


export const getAllDoctors = async () => { //doctors and residents
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "users/get_doctors",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const getAllResidents = async () => { //residents only
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      type: "resident"
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "users/get_doctors",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const getPCPDoctors = async () => { //PCP doctors only
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      specialization: "PCP" || "PRIMARY CARE PHYSICIANS"
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "users/get_doctors",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};


